import { forwardRef } from 'react';
import type { ButtonHTMLAttributes, CSSProperties } from 'react';
import { kaiTypographyWeb } from '../../typography';
import { adminCommonColors } from './adminCommonColors';
import { resolveStyleOverride, type StyleOverride } from './styleOverrides';

export const COMMON_ACTION_BUTTON_DISABLED_STYLE: CSSProperties = {
  cursor: 'not-allowed',
};

const COMMON_ACTION_BUTTON_STYLE: CSSProperties = {
  minHeight: 32,
  borderRadius: 5,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  ...kaiTypographyWeb.xSmallTitleBold,
  letterSpacing: '0.24px',
  backgroundColor: adminCommonColors.surface,
  border: 0,
  padding: '0 12px',
  cursor: 'pointer',
  appearance: 'none',
};

export type CommonActionButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  /** Emotion-free override slot kept close to the renovator shape. */
  styleOverride?: StyleOverride;
};

// Web-only admin primitive extracted from renovator CommonActionButton without Emotion.
export const CommonActionButton = forwardRef<HTMLButtonElement, CommonActionButtonProps>(
  ({ styleOverride: buttonCss, style, type = 'button', disabled = false, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type={type}
        disabled={disabled}
        style={{
          ...COMMON_ACTION_BUTTON_STYLE,
          ...(disabled ? COMMON_ACTION_BUTTON_DISABLED_STYLE : undefined),
          ...style,
          ...resolveStyleOverride(buttonCss),
        }}
        {...props}
      />
    );
  },
);

CommonActionButton.displayName = 'CommonActionButton';
